// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-page-content {
    min-height: 100%;
    box-sizing: border-box;
    font-family: var(--paragraphFont);
    display: flex;
    justify-content: center;
}

.payment-preview {
    width: 70%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(225deg, rgb(228, 32, 215), rgb(15, 182, 238))
}
.payment-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    box-sizing: border-box;
    background-color: #fff;
    width: 30%;
    height: calc(100vh - var(--menuBarHeight));
    overflow-y: auto;
    padding: min(15px, 3vmin) min(30px, 5vmin);
    gap: min(30px, 5vmin);
}

.payment-form {
    align-items: center;
    gap: 20px;
    width: 100%;
}

.extra-info h1 {
    font-size: 36px;
    font-weight: 700;
    padding: 0;
    margin: 0;
}
.extra-info h2 {
    font-size: 20px;
    font-weight: 700;
    padding: 0;
    margin: 0;
}

.extra-info p {
    margin: 0;
    padding: 0;
}

/* Small screens - wrap payment component to the bottom */
@media screen and (max-width: 1025px) {
    .payment-page-content {
        flex-direction: column;
    }
    .payment-container {
        width: 100% !important;
        height: unset !important;
    }
    .payment-preview {
        width: 100% !important;
        overflow: hidden;
    }
}

/* Image previewer & overflow stuff */
.payment-image-editor {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background-size: cover;
    overflow: auto;
}
.payment-image-preview-pane {
    overflow: visible;
    min-height: 100%;
    display: flex;
    align-items: center;
}
.payment-padding-provider {
    padding: 20px;
    width: -moz-fit-content;
    width: fit-content;
    margin: auto;
}

.payment-image-editor::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}
.payment-image-editor::-webkit-scrollbar-track {
    background: transparent;
}
.payment-image-editor::-webkit-scrollbar-thumb {
    background: rgba(207, 209, 211, 0.938);
}
.payment-image-editor::-webkit-scrollbar-thumb:hover {
    background: rgba(208, 211, 213, 0.873);
}
.payment-image-editor::-webkit-scrollbar-corner {
    background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/styles/payment/PaymentPage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;IACjC,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,UAAU;IACV,0CAA0C;IAC1C,gBAAgB;IAChB,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA,yDAAyD;AACzD;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;IACA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;AACJ;;AAEA,qCAAqC;AACrC;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,uBAAuB;AAC3B","sourcesContent":[".payment-page-content {\n    min-height: 100%;\n    box-sizing: border-box;\n    font-family: var(--paragraphFont);\n    display: flex;\n    justify-content: center;\n}\n\n.payment-preview {\n    width: 70%;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-image: linear-gradient(225deg, rgb(228, 32, 215), rgb(15, 182, 238))\n}\n.payment-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow-y: auto;\n    box-sizing: border-box;\n    background-color: #fff;\n    width: 30%;\n    height: calc(100vh - var(--menuBarHeight));\n    overflow-y: auto;\n    padding: min(15px, 3vmin) min(30px, 5vmin);\n    gap: min(30px, 5vmin);\n}\n\n.payment-form {\n    align-items: center;\n    gap: 20px;\n    width: 100%;\n}\n\n.extra-info h1 {\n    font-size: 36px;\n    font-weight: 700;\n    padding: 0;\n    margin: 0;\n}\n.extra-info h2 {\n    font-size: 20px;\n    font-weight: 700;\n    padding: 0;\n    margin: 0;\n}\n\n.extra-info p {\n    margin: 0;\n    padding: 0;\n}\n\n/* Small screens - wrap payment component to the bottom */\n@media screen and (max-width: 1025px) {\n    .payment-page-content {\n        flex-direction: column;\n    }\n    .payment-container {\n        width: 100% !important;\n        height: unset !important;\n    }\n    .payment-preview {\n        width: 100% !important;\n        overflow: hidden;\n    }\n}\n\n/* Image previewer & overflow stuff */\n.payment-image-editor {\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    background-size: cover;\n    overflow: auto;\n}\n.payment-image-preview-pane {\n    overflow: visible;\n    min-height: 100%;\n    display: flex;\n    align-items: center;\n}\n.payment-padding-provider {\n    padding: 20px;\n    width: fit-content;\n    margin: auto;\n}\n\n.payment-image-editor::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n.payment-image-editor::-webkit-scrollbar-track {\n    background: transparent;\n}\n.payment-image-editor::-webkit-scrollbar-thumb {\n    background: rgba(207, 209, 211, 0.938);\n}\n.payment-image-editor::-webkit-scrollbar-thumb:hover {\n    background: rgba(208, 211, 213, 0.873);\n}\n.payment-image-editor::-webkit-scrollbar-corner {\n    background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
